/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Converting_ToastInputs */

const en_render_audio_converting_toast = /** @type {(inputs: Render_Audio_Converting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converting text to speech audio...`)
};

const fr_render_audio_converting_toast = /** @type {(inputs: Render_Audio_Converting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversion du texte en audio...`)
};

const de_render_audio_converting_toast = /** @type {(inputs: Render_Audio_Converting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umwandlung von Text in Sprachausgabe...`)
};

const it_render_audio_converting_toast = /** @type {(inputs: Render_Audio_Converting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversione del testo in audio vocale...`)
};

const ru_render_audio_converting_toast = /** @type {(inputs: Render_Audio_Converting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразование текста в аудиозапись речи...`)
};

const es_render_audio_converting_toast = /** @type {(inputs: Render_Audio_Converting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir texto en audio de voz...`)
};

const zh_cn2_render_audio_converting_toast = /** @type {(inputs: Render_Audio_Converting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将文本转换为语音音频...`)
};

const ja_render_audio_converting_toast = /** @type {(inputs: Render_Audio_Converting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを音声オーディオに変換しています...`)
};

const hi_render_audio_converting_toast = /** @type {(inputs: Render_Audio_Converting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट को ऑडियो स्पीच में परिवर्तित किया जा रहा है...`)
};

const pt_pt2_render_audio_converting_toast = /** @type {(inputs: Render_Audio_Converting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter texto em áudio de fala...`)
};

/**
* | output |
* | --- |
* | "Converting text to speech audio..." |
*
* @param {Render_Audio_Converting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_converting_toast = /** @type {((inputs?: Render_Audio_Converting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Converting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_render_audio_converting_toast(inputs)
	if (locale === "de") return de_render_audio_converting_toast(inputs)
	if (locale === "it") return it_render_audio_converting_toast(inputs)
	if (locale === "ru") return ru_render_audio_converting_toast(inputs)
	if (locale === "es") return es_render_audio_converting_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_render_audio_converting_toast(inputs)
	if (locale === "ja") return ja_render_audio_converting_toast(inputs)
	if (locale === "hi") return hi_render_audio_converting_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_render_audio_converting_toast(inputs)
	return en_render_audio_converting_toast(inputs)
});